import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import StaffCommentSubjectsPage from './staff-comment-subjects'

const staffCommentSubjectRoutes: Route[] = [
  {
    path: Paths.SETTING_STAFF_COMMENT_SUBJECTS,
    element: <StaffCommentSubjectsPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default staffCommentSubjectRoutes
